import { get } from 'lodash';

const root = (state) => get(state, 'SKU');

export const getSkuOptions = (state) => get(root(state), 'skuOptions', false);
export const getAllowedOptions = (state) =>
  get(root(state), 'allowedOptions', false);
